// extracted by mini-css-extract-plugin
module.exports = {"calendarExample":"index_calendarExample_2sQxF"};